import { filtersAtom } from "@/hooks/useCurrentFilters";
import { useAtom } from "jotai";
import { Col, Row } from "@/utils/bootstrap";
import {
  clearAllFilters,
  filtersEmpty,
  getCurrFilters,
  isFiltesEqual,
  prepareQueryToRouter,
} from "../../flters-helpers/filter-functions";
import Filter from "../Filter";
import FilterHeader from "./FilterHeader";
import Drawer, { drawerAtom } from "@/app/components/lib/Drawer";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import { useIsMobile } from "@/hooks/useIsMobile";
import { useSearchParams } from "next/navigation";
import { usePushQueryToRouter } from "@/utils/functions/pushQueryToRouter";
import { useTranslation } from "@/hooks/localization/useTranslations";

const MobileFilter = () => {
  const searchParams = useSearchParams();
  const pushQueryToRouter = usePushQueryToRouter();
  const [filtersIds, setFilterIds] = useAtom(filtersAtom);
  const [, setShow] = useAtom(drawerAtom);
  const t = useTranslation();
  const currFilters = getCurrFilters(searchParams, filtersIds);
  const emptyFilters = filtersEmpty(currFilters);
  const filtersNotChanged = isFiltesEqual(searchParams, filtersIds);
  const mobile = useIsMobile();
  if (!mobile) return <></>;
  return (
    <Drawer>
      <FilterHeader title={t?.filters} />
      <Filter />
      <Row className="me-0 ms-0" style={{ gap: 16, marginTop: 56 }}>
        <Col className="p-0">
          <CustomButton
            type={BtnTypes.venDolsy}
            size={BtnSizes.medium}
            radius={BtnRadius.small}
            notAllowed={emptyFilters}
            onClick={() => {
              const empty = clearAllFilters(filtersIds);
              setFilterIds(empty);
              pushQueryToRouter.pushQueryToRouter(empty);
              setShow(false);
            }}
            fullWidth
          >
            {t?.clear_filters}
          </CustomButton>
        </Col>
        <Col className="p-0">
          <CustomButton
            type={BtnTypes.primary}
            size={BtnSizes.medium}
            radius={BtnRadius.small}
            notAllowed={filtersNotChanged}
            onClick={() => {
              const filtersQuery = prepareQueryToRouter(filtersIds);
              pushQueryToRouter.pushQueryToRouter(filtersQuery);
              setShow(false);
            }}
            fullWidth
          >
            {t?.apply}
          </CustomButton>
        </Col>
      </Row>
    </Drawer>
  );
};

export default MobileFilter;
